"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var utils_1 = require("../utils");

var entities_1 = require("../entities");

var ApproveErc20_1 = require("./ApproveErc20");
/**
 * @hidden
 */


exports.createRefreshSecurityTokenFactoryResolver = function (factories, securityTokenId) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", factories.securityTokenFactory.refresh(securityTokenId));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
/**
 * @hidden
 */


exports.createRefreshSimpleStoFactoryResolver = function (factories, simpleStoId) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", factories.simpleStoFactory.refresh(simpleStoId));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  };
};
/**
 * Procedure that invests in a Simple STO
 */


var InvestInSimpleSto =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(InvestInSimpleSto, _Procedure_1$Procedur);

  function InvestInSimpleSto() {
    var _this2;

    _classCallCheck(this, InvestInSimpleSto);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(InvestInSimpleSto).apply(this, arguments));
    _this2.type = types_1.ProcedureType.InvestInSimpleSto;
    return _this2;
  }
  /**
   * Buy Security Tokens from the STO
   *
   * Note that this procedure will fail if:
   * - The Security Token doesn't exist
   * - The STO address is invalid
   * - The STO is either archived or hasn't been launched
   * - The STO hasn't started yet
   * - The STO is paused
   * - The STO has already been finalized
   * - Attempting to invest on behalf of another address when beneficial investments aren't allowed for the STO
   * - The STO doesn't support investments in the selected currency
   */


  _createClass(InvestInSimpleSto, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var args, context, stoAddress, symbol, amount, beneficiary, contractWrappers, factories, stoModule, securityTokenId, simpleStoId, sto, isFinalized, isPaused, startDate, beneficialInvestmentsAllowed, _sto$fundraiseCurrenc, currency, currentAddress, resolvers;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                args = this.args, context = this.context;
                stoAddress = args.stoAddress, symbol = args.symbol, amount = args.amount;
                beneficiary = args.beneficiary;
                contractWrappers = context.contractWrappers, factories = context.factories;
                /*
                 * Validation
                 */

                _context3.prev = 4;
                _context3.next = 7;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 7:
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](4);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 12:
                if (utils_1.isValidAddress(stoAddress)) {
                  _context3.next = 14;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.InvalidAddress,
                  message: "Invalid STO address ".concat(stoAddress)
                });

              case 14:
                _context3.next = 16;
                return contractWrappers.moduleFactory.getModuleInstance({
                  name: contract_wrappers_1.ModuleName.CappedSTO,
                  address: stoAddress
                });

              case 16:
                stoModule = _context3.sent;

                if (stoModule) {
                  _context3.next = 19;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "STO ".concat(stoAddress, " is either archived or hasn't been launched")
                });

              case 19:
                securityTokenId = entities_1.SecurityToken.generateId({
                  symbol: symbol
                });
                simpleStoId = entities_1.SimpleSto.generateId({
                  securityTokenId: securityTokenId,
                  stoType: types_1.StoType.Simple,
                  address: stoAddress
                });
                _context3.next = 23;
                return factories.simpleStoFactory.fetch(simpleStoId);

              case 23:
                sto = _context3.sent;
                isFinalized = sto.isFinalized, isPaused = sto.isPaused, startDate = sto.startDate, beneficialInvestmentsAllowed = sto.beneficialInvestmentsAllowed, _sto$fundraiseCurrenc = _slicedToArray(sto.fundraiseCurrencies, 1), currency = _sto$fundraiseCurrenc[0];
                _context3.next = 27;
                return context.currentWallet.address();

              case 27:
                currentAddress = _context3.sent;

                if (!(startDate > new Date())) {
                  _context3.next = 30;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "Cannot invest in STO ".concat(stoAddress, " because it hasn't started yet")
                });

              case 30:
                if (!isFinalized) {
                  _context3.next = 32;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "STO ".concat(stoAddress, " has already been finalized")
                });

              case 32:
                if (!isPaused) {
                  _context3.next = 34;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "STO ".concat(stoAddress, " is paused")
                });

              case 34:
                if (!(beneficiary && beneficiary !== currentAddress && !beneficialInvestmentsAllowed)) {
                  _context3.next = 36;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "Cannot invest on behalf of ".concat(beneficiary, " because this STO doesn't allow beneficial investments")
                });

              case 36:
                resolvers = [exports.createRefreshSimpleStoFactoryResolver(factories, simpleStoId), exports.createRefreshSecurityTokenFactoryResolver(factories, securityTokenId)];

                if (!(currency === types_1.Currency.ETH)) {
                  _context3.next = 43;
                  break;
                }

                beneficiary = beneficiary || currentAddress;
                _context3.next = 41;
                return this.addTransaction(stoModule.buyTokens, {
                  tag: types_1.PolyTransactionTag.BuyTokens,
                  resolvers: resolvers
                })({
                  beneficiary: beneficiary,
                  value: amount
                });

              case 41:
                _context3.next = 49;
                break;

              case 43:
                if (!beneficiary) {
                  _context3.next = 45;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'This STO does not support investing in POLY on behalf of someone else'
                });

              case 45:
                _context3.next = 47;
                return this.addProcedure(ApproveErc20_1.ApproveErc20)({
                  amount: amount,
                  spender: stoAddress
                });

              case 47:
                _context3.next = 49;
                return this.addTransaction(stoModule.buyTokensWithPoly, {
                  tag: types_1.PolyTransactionTag.BuyTokensWithPoly,
                  resolvers: resolvers
                })({
                  investedPOLY: amount
                });

              case 49:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 9]]);
      }));
    }
  }]);

  return InvestInSimpleSto;
}(Procedure_1.Procedure);

exports.InvestInSimpleSto = InvestInSimpleSto;